module.exports = __webpack_public_path__ + "static/media/via_compras_mobile.70f1beb6.jpg";